import { Component, OnInit, Input } from '@angular/core';
import { PlayerService } from '../../../player/services/player.service';

@Component({
  selector: 'data-domain',
  templateUrl: './domain.component.html',
  styleUrls: ['./domain.component.css']
})
export class DomainComponent implements OnInit {

  public domainInfo: any = null;
  @Input() data: any = null;
  @Input() item: any = null;
  public domains = {
    'dm': {
      title: 'Discover New Music',
      icon: 'discover-new-music',
      link: 'discover-new-music',
    },
    'ase': {
      title: 'Advanced Search',
      icon: 'advanced-search',
      link: 'advanced-search',
    },
    'wf': {
      title: 'WeGet Official',
      icon: 'weget-official',
      link: 'playlist',
      slug: true
    },
    'r': {
      title: 'Radio',
      icon: 'radio',
      link: 'radio',
    },
    'mp': {
      title: 'Most Played',
      icon: 'most-played',
      link: 'most-played',
    },
    'md': {
      title: 'Most Downloaded',
      icon: 'most-downloaded',
      link: 'most-downloaded',
    },
    'ml': {
      title: 'Most Licensed',
      icon: 'most-licensed',
      link: 'most-licensed',
    },
    'nm': {
      title: 'Newest Music',
      icon: 'newest-music',
      link: 'newest-music',
    },
    'm': {
      title: 'Music for Movies',
      icon: 'music-for-movies',
      link: 'playlist',
      slug: true
    },
    'ac': {
      title: 'Activity Playlists',
      icon: 'activities-playlists',
      link: 'playlist',
      slug: true
    },
    'f': {
      title: 'Fans Playlists',
      icon: 'fans-playlists',
      link: 'playlist',
      slug: true
    },
    'b': {
      title: 'Business Playlists',
      icon: 'business-playlists',
      link: 'playlist',
      slug: true
    },
    'g': {
      title: 'Genre Playlists',
      icon: 'genres-playlists',
      link: 'playlist',
      slug: true
    },
    'p': {
      title: 'My Playlists',
      icon: 'my-playlists',
      link: 'my-playlists',
    },
    'mc': {
      title: 'My Music Collection',
      icon: 'my-music-library',
      link: 'my-music-library',
    },
    'mr': {
      title: 'My Radio',
      icon: 'my-radio',
      link: 'my-radio',
    },
    'ds': {
      title: 'My Discoveries',
      icon: 'my-discoveries',
      link: 'my-discoveries',
    },
    'a': {
      title: 'Artist',
      icon: 'artist.svg',
      link: 'artist',
      slug: true
    },
    's': {
      title: 'Song',
      icon: 'music-note.svg',
      link: 'song',
      slug: true
    },
    'c': {
      title: 'Collection',
      icon: 'MY_COLLECTION.svg',
      link: 'collection',
      slug: true
    },
    'u': {
      title: 'User Profile',
      icon: 'LIKE.svg',
      link: 'account',
      slug: true
    },
    'se': {
      title: 'Search',
      icon: 'ic_search_white_24px.svg',
      link: 'search',
      slug: false,
      query: true
    },
  };



  constructor(private playerService: PlayerService) { }

  ngOnInit() {
    let domainCode = (this.data.domain) ? this.data.domain.toLowerCase() : '';
    this.domainInfo = this.detectDomain(domainCode);
  }

  /* process domain and filters icon*/
  public detectDomain(domain: string) {
    if (this.domains[domain]) {
      return this.domains[domain];
    }
    return null;
  }

  public openRadioPlayer(radioID) {
    this.playerService.playSpecificRadio(radioID);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/data-tables/domain/domain.component.ts